import classNames from "classnames";
import Link from "next/link";
import Button from "../../../components/Button/Button";
import { ReadArticleProps } from "../../../types/ReadArticleProps";
import styles from "./ReadArticle.module.scss";

const ReadArticle = ({ desc, image, readLink, title }: ReadArticleProps) => {
  return (
    <div className={classNames(styles.element)}>
      <div className={classNames(styles.content)}>
        <span>Latest news</span>
        <h4>{title}</h4>
        <div dangerouslySetInnerHTML={{ __html: desc }} />
        <Link href={readLink ?? "/"}>
          <a>
            <Button text="Read article" />
          </a>
        </Link>
      </div>
      <div className={classNames(styles.image)}>
        <img src={image} alt="" />
      </div>
    </div>
  );
};

export default ReadArticle;
